<template>
  <chart :options="options" />
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/variable-pie'
exportingInit(Highcharts)

export default {
  components: {
    Chart
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    currencyInfo() {
      const type = (this.data.type || '').toLowerCase()
      let color = '#13a2e8'
      let symbol = ''
      switch (type) {
        case 'tl':
          color = '#13a2e8' // mavi
          symbol = '₺'
          break
        case 'euro':
          color = '#00008b' // lacivert
          symbol = '€'
          break
        case 'altın':
          color = '#ffd700' // sarı
          symbol = 'gr'
          break
        case 'dolar':
          color = '#008000' // yeşil
          symbol = '$'
          break
        default:
          color = '#13a2e8'
          symbol = ''
      }
      return { color, symbol }
    },
    options() {
      return {
        colors: [this.currencyInfo.color],
        chart: {
          width: 800,
          height: 400,
          type: 'column',
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '8px'
          }
        },
        title: {
          text: '',
          style: {
            display: 'none'
          }
        },
        subtitle: {
          text: '',
          style: {
            display: 'none'
          }
        },
        xAxis: {
          categories: this.data.x
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: `<tr><td style="color:{series.color};padding:0">{series.name}: </td>
                        <td style="padding:0"><b>{point.y:.0f} ${this.currencyInfo.symbol}</b></td></tr>`,
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '14px'
          }
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            style: {
              fontFamily: 'BwGlennSans-Medium',
              fontSize: '11px',
              color: 'white',
              textOutline: false
            }
          }
        },
        series: [
          {
            name: this.data.name,
            data: this.data.y,
            color: this.currencyInfo.color
          }
        ],
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        }
      }
    }
  }
}
</script>
